import { render, staticRenderFns } from "./SnackbarFlashMessage.vue?vue&type=template&id=72016e20"
import script from "./SnackbarFlashMessage.vue?vue&type=script&lang=js"
export * from "./SnackbarFlashMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports